export const cabecalhos = [
  {
    text: 'Descrição Análise',
    value: 'descricao_analise',
  },
  {
    text: 'Peso PA',
    value: 'peso_pa',
    is_number: true,
  },
  {
    text: 'Estoque PA (UND)',
    value: 'estoque_pa',
    is_number: true,
  },
  {
    text: 'Estoque PA (PESO)',
    value: 'estoque_pa_peso',
    is_number: true,
  },
  {
    text: 'Estoque MP',
    value: 'estoque_mp',
    is_number: true,
  },
  {
    text: 'Estoque Geral',
    value: 'total_estoque_peso',
    is_number: true,
  },
  {
    text: 'Projeção de vendas (UND)',
    value: 'projecao_venda_pa',
    is_number: true,
  },
  {
    text: 'Projeção de vendas (PESO)',
    value: 'projecao_venda_pa_peso',
    is_number: true,
  },
  {
    text: 'Ações',
    value: 'acoes',
    sortable: false
  }
];
